import React from "react";

import { RegisterPhoneForm } from "./register-phone-form/register-phone-form";

import "./register-phone-page.scss";

/** Страница ввода номера телефона */
export const RegisterPhonePage = () => {
  return (
    <div className={"register-phone-page"}>
      <div className="register-phone-page__title">
        Войти или зарегистрироваться
      </div>
      <RegisterPhoneForm className={"register-phone-page__form"} />
    </div>
  );
};
